export const environment = {
  API_BASE_URL: 'https://api.nutriciadev.connectedlife.io',
};
